"use client";
import "./homeMethodology.css";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import { fadeUp, staggerContainer, staggerItem } from "@lib/motion";

const STEPS = ["a", "b", "c", "d", "e"] as const;

export default function HomeMethodology() {
  const t = useTranslations("home.methodology");

  return (
    <div id="home-methodology" className="home-methodology">
      <motion.div className="home-methodology-top" {...fadeUp()}>
        <div className="home-methodology-intro">
          <p className="home-section-label">{t("label")}</p>
          <h2>{t("headline")}</h2>
        </div>
        <p className="home-methodology-body">{t("body")}</p>
      </motion.div>

      <motion.div className="home-methodology-steps" {...staggerContainer(0.3)}>
        {STEPS.map((key) => (
          <motion.div key={key} className="home-method-step" variants={staggerItem}>
            <span className="home-method-letter">{t(`steps.${key}.letter`)}</span>
            <p className="home-method-title">{t(`steps.${key}.title`)}</p>
            <p className="home-method-desc">{t(`steps.${key}.desc`)}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
